"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = exports.MapSection = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const google_maps_react_markers_1 = __importDefault(require("google-maps-react-markers"));
const react_1 = require("react");
const Marker_1 = require("./Marker");
exports.MapSection = (0, app_1.styled)(ui_1.Section) `
  padding: 0 !important;
  margin-top: ${(theme) => theme.spacing.extraLarge};
  height: ${(theme) => `calc(52rem + ${theme.spacing.extraLarge} * 2)`};
  width: 100%;
  position: relative;
  max-width: 100vw !important;
`;
function Map(_a) {
    var { className, markers, marker: Marker = Marker_1.Marker } = _a, googleMapProps = __rest(_a, ["className", "markers", "marker"]);
    const [activeMarker, setActiveMarker] = (0, react_1.useState)('1');
    const toggleMarker = (id) => setActiveMarker((currentMarker) => (currentMarker === id ? null : id));
    const activeMarkerData = (0, react_1.useMemo)(() => markers === null || markers === void 0 ? void 0 : markers.find(({ id }) => id === activeMarker), [activeMarker, markers]);
    return ((0, jsx_runtime_1.jsx)(google_maps_react_markers_1.default, Object.assign({ defaultZoom: 10, defaultCenter: {
            lat: 52.2,
            lng: 19.2,
        } }, googleMapProps, { children: markers === null || markers === void 0 ? void 0 : markers.map((place) => ((0, jsx_runtime_1.jsx)(Marker, { lat: place.position.lat, lng: place.position.lng, active: activeMarker === place.id, onClick: () => toggleMarker(place.id), activeMarker: activeMarkerData }, place.id))) })));
}
exports.Map = Map;
